module.exports = __webpack_public_path__ + "img/damage-dent.9573969d.png";